<app-welcome-page
  pageName="Signup"
  [enforcePasswordPolicy]="true"
  (buttonClicked)="onSignupClicked($event)"
>
  <span>
    Already have an account?
    <a mat-button routerLink="/login" color="primary">Sign in</a>
    .
  </span>
</app-welcome-page>
